import utils from 'utils'
import buildTask from './view/buildTask.html'
import buildTaskModalCtr from './buildTaskModalCtr'
import popUpEmploye from './view/popUpEmploye.html'
class parameterConfigurationCtrl {
    constructor($scope, httpRequest, $state, $stateParams, sweetalert, logger, initSortService, $uibModal, authService) {
        $scope.exportCollapsed = false
        const aMonth = utils.genPeriodByMonth()
        $scope.currentUserInfo = JSON.parse(localStorage.user_info).user
        $scope.select = {}
        $scope.treeConfig = {
            isCheckall: true,
            check: {
                //如果没有设置配置项，取默认配置
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
            },
        }
        $scope.queryParam = {
            pageSize: 10,
            pageNum: 1,
            param: {
                taxNo: '',
                companyName: '',
                taxplayerType: '',
            },
        }
        // 重置
        $scope.reset = function () {
            $scope.queryParam.param = {
                companyName: '',
                taxNo: '',
                status: '',
            }
            $scope.belleRegionCityList = []
            getUserInfo()
        }
        $scope.params = {
            pageSize: 2000,
            pageNum: 1,
            param: {
                isRoleOwner: '1', // 拥有本机构角色
                orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
            },
        }
        // 选中的购方信息
        $scope.selectedBuyers = []
        //自动查询展示
        const queryOrgInfo = function queryOrgInfo() {
            const openLoading =
                $scope.queryParam.pageSize >= 100
                    ? window.layer.msg('正在查询，请耐心等待', {
                          time: 0,
                          skin: 'layer-loading-self',
                          icon: 16,
                          shade: 0.5,
                      })
                    : null
            httpRequest
                .post_getRpaGsConfigDtoList(queryDataHandle($scope.queryParam))
                .then((res) => {
                    $scope.listData = res.data.value.list
                    $scope.totalItems = res.data.value.total
                    $scope.queryParam.pageNum = res.data.value.pageNum
                    $scope.selectedBuyers = []
                })
                .finally(() => {
                    window.layer.close(openLoading)
                })
        }
        function queryDataHandle(queryData) {
            $scope.employeeList = []
            const { selectedFollower } = $scope.select
            selectedFollower.forEach((item) => {
                $scope.employeeList.push({ employeeName: item.employeeName, employeeNumber: item.employeeNumber })
            })
            queryData.param.employeeList = $scope.employeeList
            return queryData
        }
        // 搜索
        $scope.searchList = function () {
            queryOrgInfo()
        }
        // 分页
        $scope.pageChanged = function () {
            // 点击页码发起查询
            queryOrgInfo()
        }
        //启用状态
        const typecodeArrStr = '["taxplayer_type", "status", "company_type","gs_applyType","department_no"]'
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = res.data.value
        })
        //获取所属大区 获取地区时两个参数都不传，获取管理城市时事业部和地区两个都要传
        httpRequest.get_getBelleRegion().then((res) => {
            $scope.belleRegionList = res.data.value
        })
        // 获取主管税局所在省市
        httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
            $scope.dictDataProvince = res.data.value
        })
        // 获取所有申报期
        httpRequest.get_queryByIdAndStatus(0).then((res) => {
            // 返回按月数据
            $scope.allApplyPeriod = res.data.value.filter((item) => {
                return item.reportingPeriod == '1'
            })
        })
        httpRequest.post_usersInfo($scope.params).then((res) => {
            $scope.currentFollowerList = res.data.value.list
        })
        function getUserInfo() {
            httpRequest.get_getIvatEmployeeList().then((res) => {
                $scope.followerList = dataHandle(res.data.value)
                $scope.select.selectedFollower = $scope.followerList.filter((x) => {
                    return x.employeeName == $scope.currentUserInfo.realName
                })
                queryOrgInfo()
            })
        }
        getUserInfo()
        function dataHandle(list) {
            list.forEach((el, index) => {
                el.orgId = index
                el.orgName = el.employeeName + '|' + el.employeeNumber
                if ($scope.currentUserInfo.realName == el.employeeName) {
                    el.checked = true
                } else {
                    el.checked = false
                }
            })
            return list
        }
        $scope.queryOrgInfo = queryOrgInfo
        $scope.tableDropdownConfig = [
            {
                label: '编辑',
                handler(item) {
                    $state.go('declaration.personalIncomeTax.parameterConfiguration.edit', {
                        id: item.id,
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('edit_configuration')
                },
            },
            {
                label: '禁用',
                handler(item) {
                    const params = {
                        id: item.id,
                        status: 0,
                    }
                    sweetalert.confirm('禁用提醒', '确认禁用此信息').then(() => {
                        httpRequest.get_getRpaGsConfigNo(params).then((res) => {
                            if (res.status == 200) {
                                logger.logSuccess('禁用成功！')
                            } else {
                                logger.logError('禁用失败！')
                            }
                            queryOrgInfo()
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return (item.status == 1 ? true : false) && hasPermit('config_go')
                },
            },
            {
                label: '启用',
                handler(item) {
                    const params = {
                        id: item.id,
                        status: 1,
                    }
                    sweetalert.confirm('启用提醒', '确认启用此信息').then(() => {
                        httpRequest.get_getRpaGsConfigNo(params).then((res) => {
                            if (res.status == 200) {
                                logger.logSuccess('启用成功！')
                            } else {
                                logger.logError('启用失败！')
                            }
                            queryOrgInfo()
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return (item.status == 0 ? true : false) && hasPermit('config_go')
                },
            },
        ]
        // 导入配置
        $scope.importconfig = {
            code: 'CONFIG_IMPORT',
            appName: '/etcloud/etcloud-ivat/',
            url: 'taxdeclaration/rpaGsConfig/importBill',
            downloadAppName: '/etcloud/etcloud-ivat/',
            downloadCode: 'GSCONFIG_NOTIMPORT',
            downloadUrl: 'taxdeclaration/rpaGsConfig/exportRpaGsConfigTemple',
            validate: {
                pattern: '.xlsx,.xls,.xml,.txt',
                _validate: {
                    size: {
                        min: 10,
                        max: '10MB',
                    },
                    duration: {
                        min: '10s',
                        max: '5m',
                    },
                    accept: '.xlsx,.xls,.xml,.txt',
                },
            },
            // 回话失效 退出登录
            handleTaxImport(res) {
                authService.logout()
                // if (res.data.msgCode == 10001) {
                //   $timeout(() => {
                //     authService.logout();
                //   });
                // }
            },
            callback() {
                // 确定后回调，可选
                queryOrgInfo()
            },
        }
        $scope.customizedConfig = {
            version: 1.142,
            queryConfig: [
                {
                    label: '纳税人识别号',
                    selected: true,
                    default: true,
                },
                {
                    label: '纳税人名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '启用状态',
                    selected: false,
                    default: false,
                },
                {
                    label: '事业部',
                    selected: false,
                    default: false,
                },
                {
                    label: '所属大区',
                    selected: false,
                    default: false,
                },
                {
                    label: '管理城市',
                    selected: false,
                    default: false,
                },
                {
                    label: '主管税局所在省(市)',
                    selected: false,
                    default: false,
                },
                {
                    label: '申报方案',
                    selected: false,
                    default: false,
                },
                {
                    label: '跟进人',
                    selected: false,
                    default: false,
                },
                {
                    label: '创建人',
                    selected: false,
                    default: false,
                },
                {
                    label: '创建时间',
                    selected: false,
                    default: false,
                },
                {
                    label: '最近修改人',
                    selected: false,
                    default: false,
                },
                {
                    label: '最近修改时间',
                    selected: false,
                    default: false,
                },
            ],
            table: [
                {
                    label: '纳税人识别号',
                    selected: true,
                    default: true,
                },
                {
                    label: '纳税人名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '跟进人账号',
                    selected: true,
                    default: true,
                },
                {
                    label: '跟进人姓名',
                    selected: true,
                    default: true,
                },
                {
                    label: '主管税局所在省(市)',
                    selected: true,
                    default: true,
                },
                {
                    label: '个税平台登录名',
                    selected: true,
                    default: true,
                },
                {
                    label: '个税平台申报密码变量',
                    selected: true,
                    default: true,
                },
                {
                    label: '办税文件共享路径',
                    selected: true,
                    default: true,
                },
                {
                    label: '申报方案',
                    selected: true,
                    default: true,
                },
                {
                    label: '启用状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '事业部',
                    selected: false,
                    default: false,
                },
                {
                    label: '所属大区',
                    selected: false,
                    default: false,
                },
                {
                    label: '管理城市',
                    selected: false,
                    default: false,
                },
                {
                    label: '创建人',
                    selected: false,
                    default: false,
                },
                {
                    label: '创建时间',
                    selected: false,
                    default: false,
                },
                {
                    label: '最近修改人',
                    selected: false,
                    default: false,
                },
                {
                    label: '最近修改时间',
                    selected: false,
                    default: false,
                },
            ],
        }
        // 联动查询管理城市
        $scope.linkageQuery = function (enumName) {
            let departmenNoObj = $scope.dictData.department_no.find((v) => {
                return v.enumName === enumName
            })
            let belleRegionListObj = $scope.belleRegionList.find((v) => {
                return v.regionName === enumName
            })
            if (departmenNoObj) {
                $scope.departmentNo = departmenNoObj.enumCode
            }
            if (belleRegionListObj) {
                $scope.regionNo = belleRegionListObj.treeLevelCode
            }
            let params = {
                affiliation: $scope.departmentNo,
                regionNo: $scope.regionNo,
            }
            if (params.affiliation == '' || params.regionNo == '') return
            httpRequest.get_getBelleRegion(params).then((res) => {
                $scope.belleRegionCityList = res.data.value
            })
        }
        // 生成任务
        $scope.buildTask = function () {
            if (!$scope.selectedBuyers.length) {
                return logger.logError('请选择数据后操作')
            }
            const modalBuildTask = $uibModal.open({
                template: buildTask,
                controller: buildTaskModalCtr,
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-lg',
                bindToController: true,
                resolve: {
                    selectedRows() {
                        return $scope.selectedBuyers
                    },
                    allApplyPeriod() {
                        return $scope.allApplyPeriod
                    },
                },
            })
            modalBuildTask.result.then(
                () => {
                    queryOrgInfo()
                },
                () => {}
            )
        }
        $scope.changeFollower = function () {
            if (!$scope.selectedBuyers.length) {
                return logger.logError('请选择数据后操作')
            }
            let configIdList = $scope.selectedBuyers.map((item) => item.id)
            $uibModal
                .open({
                    template: popUpEmploye,
                    controller: 'popUpEmployeCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal-modaldetails mod-modal mod-modal-hg',
                    resolve: {
                        modalParams() {
                            return {
                                info: $scope.currentFollowerList,
                                type: 'changeFollower',
                            }
                        },
                    },
                })
                .result.then((res) => {
                    console.log(res)
                    const { userName, realName, updateUser, updateTime } = res[0]
                    let param = {
                        configIdList,
                        employeeName: realName,
                        employeeNumber: userName,
                        updateUser,
                        updatedTime: updateTime,
                    }
                    httpRequest.post_changeConfigEmployee(param, '变更跟进人成功').then((res) => {
                        queryOrgInfo()
                    })
                })
        }
    }
}
parameterConfigurationCtrl.$inject = ['$scope', 'httpRequest', '$state', '$stateParams', 'sweetalert', 'logger', 'initSortService', '$uibModal', 'authService']
export default parameterConfigurationCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/parameterConfiguration/parameterConfigurationCtrl.js